import "./filter.css";
// import { Controller as BaseController } from "@hotwired/stimulus";
//
// export class Controller extends BaseController {
//   static targets = [];
//   static values = {};
//
//   connect() {
//   }
// }
